import { Component, Inject, OnInit } from '@angular/core';
import { DwComponent, DwComponentType, DwExpressionService, DwMetaDataFormApi, DwMetaDataFormStateService, DwMetaDataService, DwMetaDataServiceToken, DwOrmDataService, DwOrmDataServiceToken, DwSectionBaseComponent, DwUiConfigRegistryService, DwUIMetaDataConfig, DwUIMetaDataConfigToken } from '@devwareapps/devware-cap';
import { AppMetaDataItemNames, CourseLessonEntity, FlightSchoolEntity, FlightSchoolReportsCourseCountsQueryEntity, LessonTypeAllItems, VideoEntity } from '../../../../meta-data/app-meta-data.service';
import { LessonNavigationInfo } from '../../../courses/models/lesson-navigation-info.model';
import { LessonProgressHierarchy } from '../../../courses/models/lesson-progress-hierarchy.model';
import { CourseNavigationService } from '../../../courses/services/course-navigation.service';
import { CourseRepositoryService } from '../../../courses/services/course-repository.service';
import { LessonFlagUtilService } from '../../../courses/services/lesson-flag-util.service';
import { DateTimeUtilService } from '../../../shared/util/date-time-util.service';
import { SchoolRepositoryService } from '../../../schools/services/school-repository.service';


@DwComponent({
  key: 'report-course-tiles',
  name: 'Report Course Tiles',
  componentType: DwComponentType.formSection,
  isGlobal: false,
  parentItemName: AppMetaDataItemNames.FlightSchool,
})
@Component({
  selector: 'app-report-course-tiles',
  templateUrl: './report-course-tiles.component.html',
  styleUrls: ['./report-course-tiles.component.scss']
})
export class ReportCourseTilesComponent extends DwSectionBaseComponent {
  
  flightSchool: FlightSchoolEntity;
  formApi: DwMetaDataFormApi;
  courseCounts: FlightSchoolReportsCourseCountsQueryEntity[];
  
  constructor(
    dwExpressionService: DwExpressionService,
    protected dwUiConfigRegistryService: DwUiConfigRegistryService,
    @Inject(DwUIMetaDataConfigToken) uiMetaDataConfig: DwUIMetaDataConfig,
    @Inject(DwMetaDataServiceToken) dwMetaDataService: DwMetaDataService,
    @Inject(DwOrmDataServiceToken) private dataService: DwOrmDataService,
    private dwFormStateService: DwMetaDataFormStateService,
    private schoolRepositoryService: SchoolRepositoryService,
  ) {
    super(dwExpressionService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService);
    this.formApi = this.dwFormStateService.state.formApi;
  }

  setupComponentComplete(): void {
    

    this.flightSchool = this.formApi.getFormData<FlightSchoolEntity>(); 

    this.schoolRepositoryService.getSchoolCourseCounts(this.flightSchool.FlightSchoolId).subscribe(courseCounts => {
      this.courseCounts = courseCounts;
    });
  }





}
